import type { CSSProperties } from 'react';
import { Space } from 'antd';
import { ResetButton } from './ResetButton';
import { SubmitButton } from './SubmitButton';

export const FilterControlButtons = ({ onClickReset, style }: { onClickReset: () => void; style?: CSSProperties }) => (
  <Space direction="horizontal" style={style}>
    <ResetButton onClick={onClickReset} />
    <SubmitButton />
  </Space>
);
